import { create } from "zustand";
import {
  createInitialBattleState,
  transitionBattle
} from "../domain/battleMachine";
import type {
  AnswerValue,
  BattleConfiguration,
  BattleMachineState,
  BattleQuestion,
  ServerAnswerResolution
} from "../domain/battleMachine";

export type {
  AnswerValue,
  BattleConfiguration,
  BattlePhase,
  BattleQuestion,
  ImpactKind,
  ImpactTarget,
  ServerAnswerResolution
} from "../domain/battleMachine";
export { BATTLE_QUESTIONS } from "../domain/battleMachine";

interface BattleStore extends BattleMachineState {
  answer: (values: readonly AnswerValue[], useSpecial?: boolean) => void;
  applyServerAnswer: (
    values: readonly AnswerValue[],
    resolution: ServerAnswerResolution
  ) => void;
  configure: (
    questions: readonly BattleQuestion[],
    configuration?: BattleConfiguration
  ) => void;
  tick: () => void;
  clearFeedback: () => void;
  reset: () => void;
}

export const useBattleStore = create<BattleStore>((set) => ({
  ...createInitialBattleState(),
  answer: (values, useSpecial = false) => set((state) => transitionBattle(
    state,
    { type: "ANSWER", values, criticalRoll: Math.random(), useSpecial }
  )),
  applyServerAnswer: (values, resolution) => set((state) => transitionBattle(
    state,
    { type: "ANSWER_RESOLVED", values, resolution }
  )),
  configure: (questions, configuration) => set((state) => transitionBattle(
    state,
    { type: "CONFIGURE", questions, configuration }
  )),
  tick: () => set((state) => transitionBattle(state, { type: "TICK" })),
  clearFeedback: () => set((state) => transitionBattle(state, { type: "FEEDBACK_EXPIRED" })),
  reset: () => set(() => createInitialBattleState())
}));
